import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";

/** The card every sign-in / sign-up / reset page sits in. */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <Link to="/" className="bg-indigo-600 rounded-2xl p-3 mb-3">
            <Ticket className="h-7 w-7 text-white" />
          </Link>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-1 text-center">{subtitle}</p>}
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">{children}</div>
        {footer && <div className="text-center text-sm text-gray-500 mt-6">{footer}</div>}
      </div>
    </div>
  );
}
